export enum Category {
    FiltersLive = 'Filters - Live',
    FiltersNextToGo = 'Filters - Next-to-go',
    FiltersFeatured = 'Filters - Featured',
    FiltersCategorizer = 'Filters - Categorizer',
    TopSportEventsCenter = 'Top sport events - center',
    TopSportEventsRight = 'Top sport events - right',
    BannerTopSlider = 'Banner - Top slider',
    BannerTop = 'Banner - Top slider',
    BannerRight = 'Banner - Right',
    BannerRightSlider = 'Banner - Right slider',
    BannerOutright = 'Banner - Outright',
    LineOutright = 'Line - Outright',
    LineSportEvent = 'Line - Sport event',
    MatchHeader = 'Match - Header',
    MatchMarkets = 'Match - Markets',
    SidebarMarketList = 'Match - Sidebar Market List',
    AppCategory = 'App',
    Betslip = 'Betslip',
    Unknown = 'Unknown',
}

export enum Action {
    ClickOnLink = 'Click on link',
    // Live and Next to Go filters
    Open = 'Open',
    FiltersTime = 'Filter by time',
    //  Featured filters
    SelectTournament = 'Select tournament ',
    ToggleMore = 'Toggle more',
    // Categorizer filters
    SelectSport = 'Select sport',
    OpenSport = 'Open sport',
    SelectAllTournamentsSport = 'Select all tournaments in sport',
    ClearTournamentsSport = 'Clear tournaments in sport',
    // Top sport events
    FilterSport = 'Filter by sport',
    SelectOdd = 'Select odd',
    SelectMoreMarkets = 'Select more markets',
    ClickOnTitle = 'Click on title',
    // Banner
    ClickOnImage = 'Click on image',
    ClickOnButton = 'Click on button',
    ChangeSlide = 'Change slide',
    RedirectToSportEvent = 'Redirect to sport event',
    // Line sports
    OpenFullscreen = 'Open fullscreen',
    HidePromo = 'Hide promo',
    WatchPromo = 'Watch promo',
    SelectPromoOdd = 'Select promo odd',
    PlayStream = 'Play stream',
    PauseStream = 'Pause stream',
    ToggleFavorite = 'Toggle favorite',
    // Match-header
    GoBack = 'Go back',
    ChangeTab = 'Change tab',
    StatisticsBtnClick = 'match statistic button click',
    // Match markets
    ToggleMarketGroup = 'Toggle market group',
    // Location Change
    LocationChange = 'Location Change',
    ChangePage = 'Change Page',
    GoToEventView = 'Go to event view',
    // Betslip
    PlaceBet = 'Place Bet',
    DeclineBet = 'Decline Bet',
    AcceptedBet = 'Accepted Bet',
    PlaceBetMultiSingle = 'Place Bet Multi Single',
    SelectSuggest = 'Select suggest',
    PlaceOdd = 'Place Odd',
}

export enum Label {
    Open = 'open',
    Close = 'close',
    Remove = 'remove',
    Add = 'add',
    Daily = 'daily',
    Weekly = 'weekly',
    Monthly = 'monthly',
    MaxBet = 'max bet button',
}

export enum AnalyticsAttr {
    category = 'data-category',
    action = 'data-action',
    label = 'data-label',
}
